// import React from 'react'
// import './Item.css'
// import { Link } from 'react-router-dom'
// import { backend_url, currency } from '../../App'

// const Item = (props) => {
//   return (
//     <div className='item'>
//       <Link to={`/product/${props.id}`}><img onClick={window.scrollTo(0, 0)} src={backend_url+props.image} alt="products" /></Link>
//       <p>{props.name}</p>
      // <div className="item-prices">
      //   <div className="item-price-new">{currency}{props.new_price}</div>
      //   <div className="item-price-old">{currency}{props.old_price}</div>
      // </div>
//     </div>
//   )
// }

// export default Item

import React from "react";
import "./Item.css";

const Item = ({ name, image, category, readTime,new_price,old_price }) => {
  return (
    <div className="item">
      <img src={image} alt={name} />

      <div className="item-content">
        <span className="category">{category}</span>
              <div className="item-prices">
        <div className="item-price-new">{new_price}</div>
        <div className="item-price-old">{old_price}</div>
      </div>
        <h3>{name}</h3>
        <p>{readTime}</p>
      </div>
    </div>
  );
};

export default Item;